"use client";

import { useEffect } from "react";

/**
 * The root layout sits above the `[locale]` segment and renders `<html lang="en">`
 * for every page. Localized layouts mount this to correct the attribute; search
 * engines get the language from the hreflang alternates on each page.
 */
export function HtmlLang({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return null;
}
